import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { ConditionalRebate } from "Types/state";

/**********************************************************************************************************************
 * Data Driven Conditional Rebate Actions
 *********************************************************************************************************************/

/**
 * GET request/success/failure
 */
export const getConditionalRebatesRequest = actionCreator(
    "conditional_rebates/get/request",
    (vin: string, uuid: string) => ({ vin, uuid }),
    () => ({ route: API.ConditionalRebates })
);

export const getConditionalRebatesSuccess = actionCreator(
    "conditional_rebates/get/success",
    (conditionalRebates: { [vin: string]: ConditionalRebate[] }) => ({
        conditionalRebates,
    })
);

export const getConditionalRebatesFailure = actionCreator("conditional_rebates/get/failure");

/**
 * PUT request/success/failure
 */
export const putConditionalRebatesRequest = actionCreator(
    "conditional_rebates/put/request",
    (conditionalRebate: ConditionalRebate, uuid: string) => ({ conditionalRebate, uuid }),
    () => ({ route: API.ConditionalRebates })
);

export const putConditionalRebatesSuccess = actionCreator("conditional_rebates/put/success");

export const putConditionalRebatesFailure = actionCreator(
    "conditional_rebates/put/failure",
    (conditionalRebate: ConditionalRebate) => ({ conditionalRebate })
);

/**
 * DELETE request/success/failure
 */
export const deleteConditionalRebatesRequest = actionCreator(
    "conditional_rebates/delete/request",
    (conditionalRebate: ConditionalRebate, uuid: string) => ({ conditionalRebate, uuid }),
    () => ({ route: API.ConditionalRebates })
);

export const deleteConditionalRebatesSuccess = actionCreator("conditional_rebates/delete/success");

export const deleteConditionalRebatesFailure = actionCreator(
    "conditional_rebates/delete/failure",
    (conditionalRebate: ConditionalRebate) => ({ conditionalRebate })
);

/**********************************************************************************************************************
 * Hand Raiser Conditional Rebate Actions
 *********************************************************************************************************************/

/**
 * PATCH request/success/failure
 */
export const patchConditionalRebatesHandRaisersRequest = actionCreator(
    "conditional_rebates_hand_raisers/patch/request",
    (id: string, value: boolean, uuid: string) => ({ id, value, uuid }),
    () => ({ route: API.ConditionalRebates })
);

export const patchConditionalRebatesHandRaisersSuccess = actionCreator(
    "conditional_rebates_hand_raisers/patch/success"
);

export const patchConditionalRebatesHandRaisersFailure = actionCreator(
    "conditional_rebates_hand_raisers/patch/failure",
    (id: string, value: boolean) => ({ id, value })
);

/**********************************************************************************************************************
 * UI Actions
 *********************************************************************************************************************/
